import { useRoute } from '@react-navigation/native';
import { useCallback, useState } from 'react';
import { CartIcon, WebviewScreenLayout } from 'shared/src/component';
import { useMount, useNavigationGoBack, useWebviewUri } from 'shared/src/hooks';
import { useRootStackNavigation } from 'shared/src/hooks/useRootNavigation';
import { isNil } from 'shared/src/utils';
import { fillWebRoutePath } from 'shared/src/webRoutePaths';
import { HomeIcon } from 'shared/src/component/HeaderIcons';

/** `/events/:eventId` 의 path/query 파라미터. query 는 그대로 웹뷰 URL 로 승계한다. */
type EventDetailRouteParams = {
  eventId?: string;
} & Record<string, string | undefined>;

/**
 * 이벤트 상세 화면(내용은 웹뷰).
 *
 * 전용 화면으로 두는 이유는 Cart 와 같다 — 범용 `WebViewScreen` 으로 열면 목적지가 `url`
 * params 문자열로 들어가 주소가 `/events/456` 으로 유지되지 않는다.
 */
export const EventDetailScreen = () => {
  const route = useRoute();
  const { eventId, ...restParams } = (route.params ??
    {}) as EventDetailRouteParams;

  const uri = useWebviewUri(
    isNil(eventId) ? undefined : fillWebRoutePath('EventDetail', { eventId }),
    restParams,
  );
  const navigationGoBack = useNavigationGoBack();
  const navigation = useRootStackNavigation();

  const [title, setTitle] = useState<string>('');
  useMount(() => {
    navigation.setOptions({
      title,
    });
  });

  const onChangeTitle = useCallback(
    (title: string) => {
      setTitle(title);
      navigation.setOptions({
        title,
      });
    },
    [navigation],
  );
  return (
    <WebviewScreenLayout
      showHeader={true}
      onPressBack={navigationGoBack}
      title={title}
      uri={uri}
      onChangeTitle={onChangeTitle}
      rightIcons={[<HomeIcon />, <CartIcon />]}
    />
  );
};
